import type { ClientLot } from "api-types/lots/lotsResponses";

export default function getLotNumberDisplay(
  lot: Pick<ClientLot, "lotNumber" | "phase" | "block"> | null | undefined,
): string {
  if (!lot) {
    return "";
  }

  if (!lot.lotNumber) {
    return "";
  }

  let lotLabel = `${lot.lotNumber}`;
  const descriptors: string[] = [];

  if (lot.block) {
    descriptors.push(`Block ${lot.block}`);
  }

  if (lot.phase) {
    descriptors.push(`Phase ${lot.phase}`);
  }

  if (descriptors.length > 0) {
    lotLabel += ` (${descriptors.join(", ")})`;
  }
  return lotLabel;
}
